var map = {
	"./ENG_Rules_page-0001.jpg": 1878,
	"./ENG_Rules_page-0002.jpg": 140,
	"./ENG_Rules_page-0003.jpg": 9230,
	"./ENG_Rules_page-0004.jpg": 2376,
	"./ENG_Rules_page-0005.jpg": 3143,
	"./ENG_Rules_page-0006.jpg": 6300,
	"./ENG_Rules_page-0007.jpg": 4613,
	"./ENG_Rules_page-0008.jpg": 5487,
	"./ENG_Rules_page-0009.jpg": 3601,
	"./ENG_Rules_page-0010.jpg": 940,
	"./ENG_Rules_page-0011.jpg": 8092,
	"./ENG_Rules_page-0012.jpg": 9124,
	"./ENG_Rules_page-0013.jpg": 573,
	"./ENG_Rules_page-0014.jpg": 3519,
	"./ENG_Rules_page-0015.jpg": 7777,
	"./ENG_Rules_page-0016.jpg": 6698,
	"./ENG_Rules_page-0017.jpg": 6006,
	"./ENG_Rules_page-0018.jpg": 1820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8409;